import { EditorState } from "@codemirror/state";

export const manuscriptSearchPhrases = EditorState.phrases.of({
    Find: "찾기",
    Replace: "바꾸기",
    next: "다음",
    previous: "이전",
    all: "전체 선택",
    "match case": "대소문자 구분",
    regexp: "정규식",
    "by word": "단어 단위",
    replace: "바꾸기",
    "replace all": "전체 바꾸기",
    close: "닫기",
    "current match": "현재 일치",
    "on line": "줄",
    "replaced match on line $": "$줄의 일치 항목을 바꿨습니다",
    "replaced $ matches": "$개의 일치 항목을 바꿨습니다",
    the_visual_editor_cant_preview_this_type_of_image_file: "그림 미리보기를 사용할 수 없습니다.",
    click_recompile_and_check_your_pdf_to_see_how_its_looking: "컴파일 후 PDF 미리보기에서 확인해 주세요.",
    edit_figure: "그림 편집",
});
